import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/logo.png" alt="OneSource" className="h-20 w-auto" />
            </div>
            <p className="text-slate-600 text-sm mb-4 max-w-sm">
              Your strategic IT hiring partner. We connect businesses with top-tier technology talent.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="text-slate-400 hover:text-[#f9a825] transition-colors duration-200">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-[#f9a825] transition-colors duration-200">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900 mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about-us" className="text-sm text-slate-600 hover:text-slate-900 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-slate-600 hover:text-slate-900 transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-sm text-slate-600 hover:text-slate-900 transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900 mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a href="tel:+91-9121711433" className="text-sm text-slate-600 hover:text-slate-900 transition-colors duration-200 flex items-center">
                  <Phone className="w-4 h-4 mr-2" />
                  +91-9121711433
                </a>
              </li>
              <li>
                <a href="mailto:info@onesource.ind.in" className="text-sm text-slate-600 hover:text-slate-900 transition-colors duration-200 flex items-center">
                  <Mail className="w-4 h-4 mr-2" />
                  info@onesource.ind.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} OneSource IT Solutions. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <Link to="#" className="text-sm text-slate-500 hover:text-slate-900 transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="#" className="text-sm text-slate-500 hover:text-slate-900 transition-colors duration-200">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;